// Data layer for the team-library view. One cookie-authed GET /api/library.

export interface LibraryItem { shareId: string; songId: string | null; songName: string | null; ownerEmail: string | null; createdAt: string; }
export interface SetlistSummary { setlistId: string; name: string; ownerEmail: string | null; itemCount: number; createdAt: string; updatedAt: string; }
export interface TeamLibrary { teamId: string; teamName: string; items: LibraryItem[]; setlists?: SetlistSummary[]; }
export type LibraryResult =
  | { ok: true; teams: TeamLibrary[] }
  | { ok: false; needsAuth?: boolean };

export async function fetchLibrary(apiBase = '', fetchImpl: typeof fetch = fetch): Promise<LibraryResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/library`, { credentials: 'include' });
    if (res.status === 401) return { ok: false, needsAuth: true };
    if (!res.ok) return { ok: false };
    const body = await res.json() as any;
    return { ok: true, teams: Array.isArray(body?.teams) ? body.teams : [] };
  } catch {
    return { ok: false };
  }
}
